// ** React Imports
import {Link, useHistory, useLocation} from 'react-router-dom';
import { useEffect, useLayoutEffect, useState } from 'react';

// ** Custom Components
import Avatar from '@components/avatar';

// ** Reactstrap Imports
import { isMobile } from 'react-device-detect';
import { X} from "react-feather";
 import {responsiveItems} from "../../../views/community/tab/Profile";
import {useDispatch} from "react-redux";
import {setProfileTab, setSelectedRow} from "../../../views/community/tab/Profile/store/reducer";
import { LuAlignRight} from "react-icons/lu";
import {handleLogout} from "../../../redux/authentication";
import {AiOutlinePoweroff} from "react-icons/ai";
import {Offcanvas, OffcanvasBody} from "reactstrap";
export const SideBar = ({ showNav, setShowNav, userData, shortName }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [groupTab, setGroupTab] = useState('/community/profile');
  const dispatch = useDispatch();
  const userAvatar = (userData && userData?.avatar) || null;
  const history = useHistory();
  const queryLocation = useLocation();
  const queryParams = new URLSearchParams(queryLocation.search);
  const isProfileTab = queryParams.get('active');


  const clickHandler = (tabNumber) => {
    dispatch(setProfileTab(tabNumber));
  }

  useEffect(()=>{
    if(isProfileTab==="events"){
      setSelectedRow(10)
      // setProfile Tab(10)

      // setProfileTab(10)

      dispatch(setProfileTab(10));
    }else if(isProfileTab==="courses"){
      setSelectedRow(6)
      // setProfileTab(6)
      dispatch(setProfileTab(6));
    }
  },[isProfileTab])

  return (
		<Offcanvas toggle={() => setShowNav(!showNav)} isOpen={showNav} direction="end" style={{zIndex: 999999}}>
			<OffcanvasBody
				className={'p-0 position-relative'}
			>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 197.66 105.86">
					<g id="Layer_2" data-name="Layer 2">
						<g id="Layer_1-2" data-name="Layer 1">
							<rect width="197.66" height="75" fill="var(--theme-color)"/>
						</g>
					</g>
				</svg>
				<div style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					flexDirection: 'column',
				//	marginTop: "10px",
					position: 'absolute',
					top: '0',
					left: '0',
					right: '0',
					color: 'var(--theme-text-color)',
          height: '130px',
				}}>
					<div style={{width:'100%',height:'100%',display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",marginBottom:"4px"}}>
					<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
						{userAvatar ? (
							<Avatar img={userAvatar} imgHeight="40" imgWidth="40"/>
						) : (
							<Avatar
								color="secondary"
								imgHeight="60"
								imgWidth="60"
								content={shortName || 'N/A'}
								size={'xl'}
							/>
						)}
					</div>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							paddingLeft: '2px',
							fontSize: '16px',
							fontWeight: 'bold',
							cursor: 'pointer',
						//	marginTop: '20px'
						}}
						onClick={() => {
							history.push('/community/profile');
							dispatch(setProfileTab('/community/profile'));
							setGroupTab('/community/profile');
							//  setShowNav(!showNav)
						}}
					>
						{userData && userData?.fullName}
					</div>
					</div>
				</div>

				<div className="sidebar-menu">
					{responsiveItems?.map((item, index) => (
						<Link
							key={index}

							to={`profile?active=${item?.path?.toLowerCase()}`}
							onClick={() => clickHandler(item?.tabNumber)}

							to={isMobile ? `profile?active=${item.path.toLowerCase()}` : item.desktopPath}
							onClick={() => clickHandler(isMobile ? item.tabNumber : item.desktopPath)}
							className={`sidebar-item ${groupTab === item.path ? "active" : ""}`}

							onMouseEnter={() => setHoveredIndex(index)}
							onMouseLeave={() => setHoveredIndex(null)}
						>
							<div
								className="sidebar-content w-100"
								onClick={() => {

									dispatch(setProfileTab(item?.path));
									setGroupTab(item?.path);

									dispatch(setProfileTab(isMobile ? item.path : item.desktopPath));
									setGroupTab(item.path);

									setShowNav(!showNav);
								}}
							>
								{item?.icon}
								<span className="sidebar-text">{item?.str}</span>
							</div>
						</Link>
					))}

					{/* Logout Button */}
					<div className="sidebar-item logout" onClick={() => {
						dispatch(handleLogout())
						history.push("/login")
					}}>
						<AiOutlinePoweroff size={22} className="logout-icon"/>
						<span className="sidebar-text">Log Out</span>
					</div>
				</div>

				<style jsx>{`
            .sidebar-menu {
                width: 90%;
                margin: -20px auto 0 auto;
                display: flex;
                flex-direction: column;
                gap: 12px;
            }

            .sidebar-item {
                display: flex;
                align-items: center;
                text-decoration: none;
                color: #222;
                font-size: 16px;
                font-weight: 500;
                padding: 12px 16px;
                border-radius: 8px;
                transition: all 0.1s ease-in-out;
                background: white;
            }

            .sidebar-item:hover,
            .sidebar-item.active {
                background: var(--theme-color);
                color: white !important;
                box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
            }

            .sidebar-content {
                display: flex;
                align-items: center;
                gap: 9px;
            }

            .sidebar-text {
                font-weight: 600;
                font-size: 16px;
            }

            .sidebar-item.logout {
                cursor: pointer;
                color: red;
                font-weight: 600;
                margin-top: 20px;
                padding: 12px 16px;
                border-radius: 8px;
                transition: all 0.3s ease-in-out;
            }

            .sidebar-item.logout:hover {
                background: rgb(255, 0, 0);
            }

            .logout-icon {
                margin-right: 9px;
            }
				`}</style>
			</OffcanvasBody>
		</Offcanvas>
  );
};

const UserDropdown = ({ userData }) => {
  // ** Store Vars
  const userAvatar = (userData && userData?.avatar) || null;
  const [shortName, setShortName] = useState('');

  useEffect(() => {
    if (userData) {
      if (userData?.fullName) {
        const nameOrArr = String(userData?.fullName).split(' ');
        const firstPart = nameOrArr.length > 0 ? nameOrArr[0] : '';
        const lastPart = nameOrArr.length > 1 ? nameOrArr[1] : '';
        setShortName(
          `${firstPart[0].toUpperCase()}${lastPart[0] ? lastPart[0].toUpperCase() : ''}`
        );
      }
    }
  }, [userData]);
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className="ms-1 d-flex align-items-center gap-50">
      <div className="position-relative">
        <div className="user-nav d-flex flex-column justify-content-center align-items-end">
          <LuAlignRight size={30} onClick={toggle} style={{cursor: 'pointer'}}/>
        </div>
      </div>

      <SideBar
        showNav={isOpen}
        setShowNav={setIsOpen}
        userData={userData}
        userAvatar={userAvatar}
        shortName={shortName}
      />
    </div>
  );
};

export default UserDropdown;
